export const getDefaultArea = ({ index, calculatorType, lineItemName }) => {
  return {
    key: `${index}`,
    name: lineItemName ? `${lineItemName} ${index + 1}` : '',
    length: '',
    width: '',
    depth: calculatorType === 'Volume' ? '3' : '',
    squareFootage: {
      value: '',
      changed: false
    }
  };
};

export const getCoverageAndQuantity = ({
  addAdditionalCoverage, allowAdditionalCoverage, areas, calcByArea, calcByLengthWidth, calculatorType, sizeValue,
}) => {
  let coverage = 0;
  let quantity = 0;

  areas.forEach((area) => {
    let areaValue;
    if (calcByLengthWidth) {
      areaValue = area.length * area.width;
    } else if (calcByArea) {
      areaValue = Number(area.squareFootage.value);
    }
    if (calculatorType === 'Volume') {
      areaValue *= (area.depth / 12); // depth is in inches, so we must divide by 12
    }
    coverage += areaValue;
  });

  if (sizeValue) {
    let updateCoverage = coverage;
    if (allowAdditionalCoverage && addAdditionalCoverage) {
      updateCoverage += (coverage * 0.10);
    }
    quantity = Math.ceil(updateCoverage / sizeValue);
  }
  return { coverage, quantity };
};
